import {createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import authReducer from "@/reducer";

const store = createStore(authReducer, composeWithDevTools());

export default store;
